import {ClientEvent} from '@udemy/event-tracking';

/** This event is fired when an academy card is presented to the user. */
export class AcademyCourseSummaryPresented extends ClientEvent {
    constructor({academySlug, courseId}: {academySlug: string; courseId: number}) {
        super('AcademyCourseSummaryPresented');
        this.academySlug = academySlug;
        this.courseId = courseId;
    }

    academySlug: string;
    courseId: number;
}
